module.exports = __webpack_public_path__ + "img/108.10.f708c8f4.png";